export default __webpack_public_path__ + "static/cg-91722fe3f59053be976e48b425d5649f.svg";